
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23.653","height":"17.277"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_22630","data-name":"Group 22630","transform":"translate(.703 .5)"}},[_c('g',{attrs:{"id":"Group_2810","data-name":"Group 2810","fill":"none","stroke":"#c1c5cb","stroke-width":"1"}},[_c('path',{attrs:{"id":"Path_226","data-name":"Path 226","d":"M1219.119 748.2a1.649 1.649 0 11-1.649-1.649 1.649 1.649 0 011.649 1.649z","transform":"translate(-1199.796 -744.344)"}}),_c('rect',{attrs:{"id":"Rectangle_166","data-name":"Rectangle 166","width":"22.421","height":"16.277","rx":"1.666","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"id":"Path_323","data-name":"Path 323","d":"M1189.24 760.885l6.613-8.206 5.476 5.537 3.551-3.13 6.606 5.8","transform":"translate(-1189.24 -746.777)","stroke-linecap":"round","stroke-linejoin":"round"}})])])])
          )
        }
      }
    